import { render, staticRenderFns } from "./ChallengeManagerRules.vue?vue&type=template&id=12ef5d22"
import script from "./ChallengeManagerRules.vue?vue&type=script&lang=js"
export * from "./ChallengeManagerRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports